import { MDBContainer, MDBRow } from "mdb-react-ui-kit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import {
  faFacebookSquare,
  faPinterestSquare,
  faTwitterSquare,
} from "@fortawesome/free-brands-svg-icons";
import { FooterWrapper } from "./Footer.styles";
import { Link } from "react-router-dom";
import { getWhitelabelFeatures, WHITELABEL_FLAG_KEYS } from "../consts/whitelabel";
import useWhitelabelFlag from "../hooks/useWhitelabelFlag";

const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  const { footerCopyright, showFooterSocial: showFooterSocialDefault } = getWhitelabelFeatures();
  const showFooterSocial = useWhitelabelFlag(
    WHITELABEL_FLAG_KEYS.showFooterSocial,
    showFooterSocialDefault,
  );

  return (
    <FooterWrapper>
      <MDBContainer>
        <MDBRow>
          <p>
            {footerCopyright} &copy; {year}
            <br />
            <Link to="/privacy" dangerouslySetInnerHTML={{__html: t("Privacy Policy")}} />
            &nbsp;&amp;&nbsp;
            <Link to="/terms" dangerouslySetInnerHTML={{__html: t('Terms of Use')}} />
          </p>
          {showFooterSocial && (
            <div className="col-12 social">
              <a href="https://www.facebook.com/socialscavengerapp">
                <FontAwesomeIcon icon={faFacebookSquare} />
              </a>
              <a href="https://twitter.com/socialscavenger">
                <FontAwesomeIcon icon={faTwitterSquare} />
              </a>
              <a href="http://www.pinterest.com/socialscavenger/">
                <FontAwesomeIcon icon={faPinterestSquare} />
              </a>
            </div>
          )}
        </MDBRow>
      </MDBContainer>
    </FooterWrapper>
  );
};

export default Footer;
